import axios from 'axios';
import { getAccessToken } from './AuthService';

/** Placeholder endpoints — wire when backend is ready. */
const GOAL_MILESTONE_BASE =
    'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev';

const requestConfig = {
    headers: {
        'x-api-key':
            process.env.REACT_APP_AWS_API_GATEWAY_KEY ||
            'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB',
    },
};

function authBody(userId, extra = {}) {
    return {
        username: userId,
        token: getAccessToken(),
        ...extra,
    };
}

/**
 * Fetch goal text + milestones for a user.
 * @returns {{ goal: string, milestones: Array }|null}
 */
export async function fetchGoalMilestones(userId) {
    if (!userId) return null;
    const response = await axios.post(
        `${GOAL_MILESTONE_BASE}/goalmilestonefetch`,
        authBody(userId),
        requestConfig
    );
    const data = response?.data || {};
    return {
        goal: data.goal || data.textcontent || '',
        milestones: Array.isArray(data.milestones) ? data.milestones : [],
    };
}

/**
 * Persist goal text.
 */
export async function saveGoal(userId, goal) {
    if (!userId) return;
    await axios.post(
        `${GOAL_MILESTONE_BASE}/goalupdate`,
        authBody(userId, { goal }),
        requestConfig
    );
}

/**
 * Persist full milestones array.
 */
export async function saveMilestones(userId, milestones) {
    if (!userId) return;
    await axios.post(
        `${GOAL_MILESTONE_BASE}/milestoneupdate`,
        authBody(userId, { milestones }),
        requestConfig
    );
}
